module.exports = __webpack_public_path__ + "img/dribbble.325d1040.svg";